/**
 * Marks a field inside a settings body whose own Escape cancels an inline edit
 * (e.g. renaming a layout). A host that closes on Escape, like the editor
 * settings modal, leaves an Escape from such a field to the field.
 */
export const inlineEditProps = { 'data-settings-inline-edit': '' } as const

export const INLINE_EDIT_SELECTOR = '[data-settings-inline-edit]'
